import styled, { css } from 'styled-components';
import ReactSelect from 'react-select';
import { useTiresGrade } from 'pages/ListerVehicleUploadV2/hooks/useTiresGrade';
import { useUpdateImage } from 'pages/ListerVehicleUploadV2/hooks/useUpdateImage';

const controlErrorStyles = css`
  background: #e933231a;
`;

const inputErrorStyles = css`
  color: #d01c2e;
`;

const StyledSelect = styled(ReactSelect)<{ hasError: boolean }>`
  .tires-grade-select__control {
    background-color: #f6f6f6;
    border-radius: 30px;
    border: 1px solid #99999966;
    width: 68px;
    height: 32px;
    min-height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: none !important; /* Remove blue outline */
    ${props => props.hasError && controlErrorStyles}
  }

  .tires-grade-select__single-value {
    font-size: 12px;
  }

  .tires-grade-select__value-container {
    padding: 0px 8px;
  }

  .tires-grade-select__control:hover {
    border: 1px solid #99999966;
  }

  .tires-grade-select__control--is-focused {
    border: 1px solid #99999966 !important;
    box-shadow: none !important;
  }

  .tires-grade-select__single-value {
    color: #000;
    font-weight: bold;
    ${props => props.hasError && inputErrorStyles}
  }

  .tires-grade-select__dropdown-indicator {
    color: #000 !important;
    padding: 8px;

    svg {
      width: 12px;
      height: 12px;
    }
  }

  .tires-grade-select__menu {
    background-color: #f6f6f6;
    border-radius: 8px;
  }

  .tires-grade-select__indicator-separator {
    display: none;
  }

  .tires-grade-select__option {
    color: #000;
    padding: 8px;
    font-size: 12px;
  }

  .tires-grade-select__option:hover {
    background-color: #f6f6f6;
  }

  .tires-grade-select__control--is-disabled .tires-grade-select__dropdown-indicator {
    display: none;
  }

  .tires-grade-select__control--is-disabled .tires-grade-select__value-container {
    justify-content: center;
  }
`;

const options = Array.from(new Array(15)).map((_, i) => ({
  label: i,
  value: i
}));

type Option = {
  label: number;
  value: number;
};

type Props = {
  sectionId: string;
  isAiValue?: boolean;
  readOnly?: boolean;
  highlightError?: boolean;
};

export const TiresGradeSelection = ({
  sectionId,
  isAiValue = false,
  readOnly = false,
  highlightError = false
}: Props) => {
  const [level1, _0, level2, _1] = sectionId.split('.');

  const { changeGradeBasedOnNumber, value: numericGrade, imageIndex, aiValue: numericAiValue, hasError } = useTiresGrade(
    sectionId
  );

  const updateImage = useUpdateImage(`${level1}.subsections.${level2}`, imageIndex);

  const handleChange = async (o: Option) => {
    console.log('handle change triggeers', level1);
    if (isAiValue) return;

    await updateImage({ grade: o.value });
    changeGradeBasedOnNumber(o.value);
  };

  const currentValue = isAiValue ? numericAiValue : numericGrade;

  return (
    <StyledSelect
      hasError={hasError && highlightError}
      value={options.find(o => o.value === currentValue)}
      onChange={handleChange}
      isSearchable={false}
      placeholder=""
      classNamePrefix={'tires-grade-select'}
      options={options}
      isDisabled={readOnly}
    />
  );
};
